<template>
  <div :class="classes.loader"></div>
</template>

<script>
import { defineComponent } from "vue";
import { createUseStyles } from "@fresh8/vue-jss/src";

const useStyles = createUseStyles({
  loader: {
    border: "5px solid #f3f3f3",
    borderTop: "5px solid #acacac",
    borderRadius: "50%",
    width: "20px",
    height: "20px",
    animationName: "$spin",
    animationDuration: "0.5s",
    animationIterationCount: "infinite",
    animationTimingFunction: "linear",
    position: "absolute",
    margin: "auto",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },

  "@keyframes spin": {
    "0%": { transform: "rotate(0deg)" },
    "100%": { transform: "rotate(360deg)" }
  }
});

export default defineComponent({
  name: "loader",
  setup() {
    const classes = useStyles();
    return { classes };
  }
});
</script>

<style></style>
